import ServiceIcon from "@/components/ServiceIcon";
import { SERVICE_META } from "@/data/serviceAreas";
import { cn } from "@/lib/utils";

export function ServiceBadge({ serviceKey, size = "md", solid = false, className }) {
  const m = SERVICE_META[serviceKey];
  if (!m) return null;
  const sm = size === "sm";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full font-mono uppercase tracking-[0.1em]",
        sm ? "px-2.5 py-1 text-[10px]" : "px-3 py-1.5 text-[11px]",
        className
      )}
      style={
        solid
          ? { backgroundColor: m.color, color: "#fff" }
          : { backgroundColor: `${m.color}1A`, color: m.color }
      }
    >
      <ServiceIcon name={m.icon} className={sm ? "h-3 w-3" : "h-3.5 w-3.5"} />
      {m.short}
    </span>
  );
}
